import { addDatadogRumAction } from './datadogRum';
export function trackNavl(destinations) {
    addDatadogRumAction('HC NO RESULTS', { destinations });
}
export function trackNoSearchResults(search) {
    addDatadogRumAction('HC Zero Search Results', Object.assign({}, search));
}
export function trackHasSearchResults(search) {
    addDatadogRumAction('HC Has Search Results', Object.assign({}, search));
}
